import { render, staticRenderFns } from "./ErrorMessageWrapper.vue?vue&type=template&id=24a1bc58"
import script from "./ErrorMessageWrapper.vue?vue&type=script&lang=js"
export * from "./ErrorMessageWrapper.vue?vue&type=script&lang=js"
import style0 from "./ErrorMessageWrapper.vue?vue&type=style&index=0&id=24a1bc58&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports